export const cartConstants = {
	BUILDING_TREE: 'building_tree',
	BOOK_DATE: 'book_date',
	
	BOOK_FOR_OPTION: 'book_for_option',
	
	CAPACITIES: 'capacities',
	
	TIMESLOTS_SELECTED: 'timeslots_selected',
	TIMESLOTS_SELECTED_COUNT: 'timeslots_selected_count',
	
	// Timeslots
	TIMESLOTS: 'timeslots',
	TIMESLOTS_LUNCH_OPTIONS: 'timeslots_lunch_options',
	TIMESLOTS_TRANSPORT_DEFAULT_LICENSE_PLATE: 'timeslots_transport_default_license_plate',
	TIMESLOTS_TRANSPORT_LICENSE_PLATES: 'timeslots_transport_licence_plates',
	
	// External
	BOOKING_EXTERNAL_PERSONS: 'booking_external_persons',
	BOOKING_COWORKERS: 'booking_coworkers',
	BOOKING_REJECT: 'booking_reject',
	
	//
	EMPLOYEE_STATUS: 'employee_status',
};
